/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: ucQz5-5mzj2-

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicToast.module.css"; // plasmic-import: ucQz5-5mzj2-/css

import Icon72Icon from "./icons/PlasmicIcon__Icon72"; // plasmic-import: zw4EsmSkmFqr/icon
import Icon74Icon from "./icons/PlasmicIcon__Icon74"; // plasmic-import: QNu2v2LzwTz0/icon
import CheckSmall1Icon from "./icons/PlasmicIcon__CheckSmall1"; // plasmic-import: qVIxAmskjojT/icon
import WarningXSmallIcon from "./icons/PlasmicIcon__WarningXSmall"; // plasmic-import: MGFcvmbudZJ7/icon
import Icon73Icon from "./icons/PlasmicIcon__Icon73"; // plasmic-import: vcBRLGvp2fGf/icon

createPlasmicElementProxy;

export type PlasmicToast__VariantMembers = {
  type: "info" | "error" | "success" | "warning";
};
export type PlasmicToast__VariantsArgs = {
  type?: SingleChoiceArg<"info" | "error" | "success" | "warning">;
};
type VariantPropType = keyof PlasmicToast__VariantsArgs;
export const PlasmicToast__VariantProps = new Array<VariantPropType>("type");

export type PlasmicToast__ArgsType = {
  title?: string;
  description?: string;
  onClose?: () => void;
};
type ArgPropType = keyof PlasmicToast__ArgsType;
export const PlasmicToast__ArgProps = new Array<ArgPropType>(
  "title",
  "description",
  "onClose"
);

export type PlasmicToast__OverridesType = {
  toast?: Flex__<"div">;
  wrapper?: Flex__<"div">;
  accent?: Flex__<"div">;
  accentIcon?: Flex__<"svg">;
  text?: Flex__<"div">;
  close?: Flex__<"button">;
  closeIcon?: Flex__<"svg">;
};

export interface DefaultToastProps {
  title?: string;
  description?: string;
  onClose?: () => void;
  type?: SingleChoiceArg<"info" | "error" | "success" | "warning">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicToast__RenderFunc(props: {
  variants: PlasmicToast__VariantsArgs;
  args: PlasmicToast__ArgsType;
  overrides: PlasmicToast__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "type",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.type
      }
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"toast"}
      data-plasmic-override={overrides.toast}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.toast,
        {
          [sty.toasttype_error]: hasVariant($state, "type", "error"),
          [sty.toasttype_info]: hasVariant($state, "type", "info"),
          [sty.toasttype_success]: hasVariant($state, "type", "success")
        }
      )}
    >
      <div
        data-plasmic-name={"wrapper"}
        data-plasmic-override={overrides.wrapper}
        className={classNames("all", sty.wrapper)}
      >
        <div
          data-plasmic-name={"accent"}
          data-plasmic-override={overrides.accent}
          className={classNames("all", sty.accent, {
            [sty.accenttype_error]: hasVariant($state, "type", "error"),
            [sty.accenttype_success]: hasVariant($state, "type", "success"),
            [sty.accenttype_warning]: hasVariant($state, "type", "warning")
          })}
        >
          <PlasmicIcon__
            data-plasmic-name={"accentIcon"}
            data-plasmic-override={overrides.accentIcon}
            PlasmicIconType={
              hasVariant($state, "type", "warning")
                ? WarningXSmallIcon
                : hasVariant($state, "type", "success")
                  ? CheckSmall1Icon
                  : hasVariant($state, "type", "error")
                    ? Icon74Icon
                    : Icon72Icon
            }
            className={classNames("all", sty.accentIcon, {
              [sty.accentIcontype_error]: hasVariant($state, "type", "error"),
              [sty.accentIcontype_success]: hasVariant(
                $state,
                "type",
                "success"
              ),
              [sty.accentIcontype_warning]: hasVariant(
                $state,
                "type",
                "warning"
              )
            })}
            role={"img"}
          />
        </div>
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames("all", sty.text)}
        >
          <div
            className={classNames("all", "__wab_text", sty.text___1U6ZH, {
              [sty.texttype_info___1U6ZHa6P9A]: hasVariant(
                $state,
                "type",
                "info"
              )
            })}
          >
            <React.Fragment>
              {(() => {
                try {
                  return $props.title;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return "";
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          </div>
          <div
            className={classNames("all", "__wab_text", sty.text__c2FXg, {
              [sty.texttype_info__c2FXga6P9A]: hasVariant(
                $state,
                "type",
                "info"
              )
            })}
          >
            <React.Fragment>
              {(() => {
                try {
                  return $props.description;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return "";
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          </div>
        </div>
        <button
          data-plasmic-name={"close"}
          data-plasmic-override={overrides.close}
          aria-label={"Dismiss"}
          className={classNames("all", "button", "button__bvRZj", sty.close, {
            [sty.closetype_warning]: hasVariant($state, "type", "warning")
          })}
          onClick={async event => {
            const $steps = {};

            $steps["runOnClose"] = true
              ? (() => {
                  const actionArgs = { eventRef: $props["onClose"] };
                  return (({ eventRef, args }) => {
                    return eventRef?.(...(args ?? []));
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["runOnClose"] != null &&
              typeof $steps["runOnClose"] === "object" &&
              typeof $steps["runOnClose"].then === "function"
            ) {
              $steps["runOnClose"] = await $steps["runOnClose"];
            }
          }}
          ref={ref => {
            $refs["close"] = ref;
          }}
        >
          <Icon73Icon
            data-plasmic-name={"closeIcon"}
            data-plasmic-override={overrides.closeIcon}
            className={classNames("all", sty.closeIcon, {
              [sty.closeIcontype_info]: hasVariant($state, "type", "info")
            })}
            role={"img"}
          />
        </button>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  toast: [
    "toast",
    "wrapper",
    "accent",
    "accentIcon",
    "text",
    "close",
    "closeIcon"
  ],
  wrapper: ["wrapper", "accent", "accentIcon", "text", "close", "closeIcon"],
  accent: ["accent", "accentIcon"],
  accentIcon: ["accentIcon"],
  text: ["text"],
  close: ["close", "closeIcon"],
  closeIcon: ["closeIcon"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  toast: "div";
  wrapper: "div";
  accent: "div";
  accentIcon: "svg";
  text: "div";
  close: "button";
  closeIcon: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicToast__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicToast__VariantsArgs;
    args?: PlasmicToast__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicToast__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicToast__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicToast__ArgProps,
          internalVariantPropNames: PlasmicToast__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicToast__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "toast") {
    func.displayName = "PlasmicToast";
  } else {
    func.displayName = `PlasmicToast.${nodeName}`;
  }
  return func;
}

export const PlasmicToast = Object.assign(
  // Top-level PlasmicToast renders the root element
  makeNodeComponent("toast"),
  {
    // Helper components rendering sub-elements
    wrapper: makeNodeComponent("wrapper"),
    accent: makeNodeComponent("accent"),
    accentIcon: makeNodeComponent("accentIcon"),
    text: makeNodeComponent("text"),
    close: makeNodeComponent("close"),
    closeIcon: makeNodeComponent("closeIcon"),

    // Metadata about props expected for PlasmicToast
    internalVariantProps: PlasmicToast__VariantProps,
    internalArgProps: PlasmicToast__ArgProps
  }
);

export default PlasmicToast;
/* prettier-ignore-end */
